module.exports = __webpack_public_path__ + "img/telhado-paraf-madeira.9dc60edc.jpg";